import { render, staticRenderFns } from "./fiche-alerte.vue?vue&type=template&id=4c3ca09a&scoped=true&"
import script from "./fiche-alerte.vue?vue&type=script&lang=ts&"
export * from "./fiche-alerte.vue?vue&type=script&lang=ts&"
import style0 from "./fiche-alerte.vue?vue&type=style&index=0&id=4c3ca09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ca09a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
